<template>
  <div class="flex flex-wrap items-start mb-4 pb-4 border-b-2">
    <div class="md:w-4/5 flex flex-col">
      <span class="text-left pb-2 uppercase text-sm tracking-wider"
        >Pregunta {{ question.id_pregunta }}</span
      >
      <input
        :class="{ 'border-red-500': question.error }"
        class="bg-gray-200 appearance-none border-2 border-indigo-500 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-indigo-300"
        type="text"
        v-model="question.texto"
      />
      <p v-if="question.error" class="text-red-500 text-xs italic text-left">
        Ingrese la pregunta.
      </p>
    </div>
    <div class="md:w-1/5 flex justify-center">
      <button
        type="button"
        class="flex items-center px-2 py-1 rounded bg-red-500 text-gray-100 hover:bg-red-700"
        @click="remove"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 fill-current"
          viewBox="0 0 24 24"
        >
          <path
            d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
          />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </button>
    </div>
    <div class="w-full flex items-center mt-3">
      <span class="text-left uppercase text-xs tracking-wider"
        >Nota para el registrante</span
      >
    </div>
    <div class="w-full flex flex-wrap mt-3">
      <input
        class="bg-gray-200 appearance-none border-2 border-indigo-500 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-indigo-300"
        type="text"
        v-model="question.nota_para_registrante"
      />
    </div>
    <div class="w-full flex items-center mt-3">
      <label class="flex items-center text-gray-900 cursor-pointer">
        <input
          class="mr-2 appearance-none h-5 w-5 border-2 border-indigo-500 rounded-sm checked:bg-indigo-500 checked:border-transparent focus:outline-none"
          type="checkbox"
          v-model="question.obligatoria"
        />
        <span class="uppercase text-xs tracking-wider">Obligatorio</span>
      </label>
    </div>

    <div class="w-full flex items-center mt-3">
      <span class="text-left uppercase text-xs tracking-wider">Opciones</span>
      <button
        type="button"
        class="flex items-center px-2 py-2 ml-2 rounded-full bg-gray-700 text-gray-100 hover:bg-gray-900"
        @click="addOption"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 fill-current"
          viewBox="0 0 24 24"
        >
          <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </button>
      <p
        v-if="question.optionError"
        class="ml-3 text-red-500 text-xs italic text-left"
      >
        Deben llenarse todas las opciones.
      </p>
      <p
        v-if="question.minimumError"
        class="ml-3 text-red-500 text-xs italic text-left"
      >
        Deben haber al menos dos opciones.
      </p>
      <p
        v-if="question.maximumOptionError"
        class="ml-3 text-red-500 text-xs italic text-left"
      >
        Solo pueden haber un máximo de cinco opciones.
      </p>
    </div>

    <div class="w-full flex flex-wrap mt-3">
      <div
        v-for="(option, index) in question.opciones"
        :key="index"
        class="relative w-1/3 pr-2 py-2"
      >
        <input
          :class="{ 'border-red-500': option === '' && question.optionError }"
          class="bg-gray-200 appearance-none border-2 border-indigo-500 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-indigo-300"
          type="text"
          v-model="question.opciones[index]"
        />
        <button
          type="button"
          class="absolute top-0 right-0 flex items-center px-1 py-1 -mt-1 rounded-full border-2 border-gray-500 bg-gray-700 text-gray-100 hover:bg-gray-900"
          @click="removeOption(index)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-3 w-3 fill-current"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>
    </div>

    <div class="w-full flex items-center mt-3">
      <label class="flex items-center text-gray-900 cursor-pointer">
        <input
          class="mr-2 appearance-none h-5 w-5 border-2 border-indigo-500 rounded-sm checked:bg-indigo-500 checked:border-transparent focus:outline-none"
          type="checkbox"
          v-model="question.otro"
        />
        <span class="uppercase text-xs tracking-wider"
          >Añadir opción "Otro" (se agregará un campo extra para que el usuario
          escriba otra opción)</span
        >
      </label>
    </div>

    <div class="w-full flex items-center mt-3">
      <span class="text-left uppercase text-xs tracking-wider"
        >Subpreguntas</span
      >
      <button
        type="button"
        class="flex items-center px-2 py-2 ml-2 rounded-full bg-teal-500 text-gray-100 hover:bg-teal-700"
        @click="addSubquestion('open')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          class="h-6 w-6 fill-current"
          viewBox="0 0 24 24"
        >
          <defs>
            <path id="a" d="M0 0h24v24H0V0z" />
          </defs>
          <clipPath id="b">
            <use xlink:href="#a" overflow="visible" />
          </clipPath>
          <path d="M4 9h16v2H4zm0 4h10v2H4z" clip-path="url(#b)" />
        </svg>
      </button>

      <button
        type="button"
        class="flex items-center px-2 py-2 ml-2 rounded-full bg-indigo-500 text-gray-100 hover:bg-indigo-700"
        @click="addSubquestion('multiple')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 fill-current"
          viewBox="0 0 24 24"
        >
          <path
            d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
          />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </button>
      <button
        type="button"
        class="flex items-center px-2 py-2 ml-2 rounded-full bg-pink-500 text-gray-100 hover:bg-pink-700"
        @click="addSubquestion('fields')"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current">
          <path d="M7 20V7H2V4H15V7H10V20ZM16 20V12H13V9H22V12H19V20Z" />
        </svg>
      </button>
      <p
        v-if="question.maximumSubquestionError"
        class="ml-3 text-red-500 text-xs italic text-left"
      >
        Solo pueden haber un máximo de dos subpreguntas.
      </p>
    </div>
    <div class="w-full">
      <div
        v-for="(subquestion, index) in question.subpregunta"
        :key="subquestion.id_pregunta"
      >
        <open-sub-question
          v-if="subquestion.tipo === 'ABIERTA'"
          @click="removeSubquestion(index)"
          :question="subquestion"
          color="indigo"
          :ref="'subquestion' + index"
          :parentType="question.tipo"
          :parentOptions="question.opciones"
        ></open-sub-question>
        <multiple-sub-question
          v-if="subquestion.tipo === 'SELECCION'"
          @click="removeSubquestion(index)"
          :question="subquestion"
          color="indigo"
          :ref="'subquestion' + index"
          :parentType="question.tipo"
          :parentOptions="question.opciones"
        ></multiple-sub-question>
        <fields-sub-question
          v-if="subquestion.tipo === 'CAMPOS'"
          @click="removeSubquestion(index)"
          :question="subquestion"
          color="indigo"
          :ref="'subquestion' + index"
          :parentType="question.tipo"
          :parentOptions="question.opciones"
        ></fields-sub-question>
      </div>
    </div>
  </div>
</template>

<script>
import OpenSubQuestion from "./OpenSubQuestion";
import MultipleSubQuestion from "./MultipleSubQuestion";
import FieldsSubQuestion from "./FieldsSubQuestion";

export default {
  name: "multiple-question",
  data() {
    return {
      lastId: 1,
    };
  },
  components: {
    OpenSubQuestion,
    MultipleSubQuestion,
    FieldsSubQuestion,
  },
  mounted() {
    this.lastId = this.question.subpregunta.length + 1;
  },
  methods: {
    remove() {
      this.$emit("click");
    },
    addOption() {
      if (this.question.opciones.length < 5) {
        this.question.opciones.push("");
        this.question.minimumError = false;
      } else {
        this.question.maximumOptionError = true;
      }
    },
    removeOption(index) {
      if (this.question.opciones.length > 2) {
        this.question.opciones.splice(index, 1);
        this.question.minimumError = false;
        this.question.maximumOptionError = false;
      } else {
        this.question.minimumError = true;
      }
    },
    addSubquestion(type) {
      if (this.question.subpregunta.length < 2) {
        if (type === "open") {
          let question = {
            id_pregunta: this.question.id_pregunta + "." + this.lastId,
            tipo: "ABIERTA",
            texto: "",
            nota_para_registrante: "",
            error: false,
          };
          this.question.subpregunta.push(question);
          this.lastId += 1;
        }
        if (type === "multiple") {
          let question = {
            id_pregunta: this.question.id_pregunta + "." + this.lastId,
            tipo: "SELECCION",
            texto: "",
            nota_para_registrante: "",
            opciones: ["", ""],
            otro: false,
            error: false,
            optionError: false,
            minimumError: false,
            maximumOptionError: false,
          };
          this.question.subpregunta.push(question);
          this.lastId += 1;
        }
        if (type === "fields") {
          let question = {
            id_pregunta: this.question.id_pregunta + "." + this.lastId,
            tipo: "CAMPOS",
            texto: "",
            nota_para_registrante: "",
            campos: [
              {
                texto: "",
                tipo: "texto",
              },
            ],
            error: false,
            fieldError: false,
            minimumError: false,
          };
          this.question.subpregunta.push(question);
          this.lastId += 1;
        }
      } else {
        this.question.maximumSubquestionError = true;
      }
    },
    removeSubquestion(subquestionKey) {
      this.question.subpregunta.splice(subquestionKey, 1);

      this.question.subpregunta.forEach((subquestion, index) => {
        let subId = index + 1;
        subquestion.id_pregunta = this.question.id_pregunta + "." + subId;
      });

      this.lastId = this.question.subpregunta.length + 1;

      this.question.maximumSubquestionError = false;
    },
    validateQuestion() {
      this.question.minimumError = false;
      if (
        this.validateEmptyQuestion() &
        this.validateOptions() &
        this.validateSubquestions()
      ) {
        return true;
      } else {
        return false;
      }
    },
    validateEmptyQuestion() {
      if (this.question.texto === "") {
        this.question.error = true;
        return false;
      } else {
        this.question.error = false;
        return true;
      }
    },
    validateOptions() {
      let emptyOptions = this.question.opciones.filter(
        (option) => option === ""
      );
      if (emptyOptions.length > 0) {
        this.question.optionError = true;
        return false;
      } else {
        this.question.optionError = false;
        return true;
      }
    },
    validateSubquestions() {
      if (this.question.subpregunta.length > 0) {
        let validateValues = [];
        Object.keys(this.$refs).forEach((el) => {
          if (this.$refs[el][0] !== undefined) {
            let value = this.$refs[el][0].validateQuestion();
            validateValues.push(value);
          }
        });

        return validateValues.every(Boolean);
      } else {
        return true;
      }
    },
  },
  props: {
    question: {
      required: true,
    },
  },
};
</script>

<style scoped></style>
